/**
 * Shared Clue Components
 *
 * This module exports the consolidated clue-related components for
 * use across different route patterns in the scavenger hunt application.
 *
 * Components:
 * - ClueClient: Main client component for clue display and NFC claiming
 * - ClueWrapper: Wrapper that provides SessionProvider context
 * - ClaimForm: Form for legacy claim flow
 * - EligibilityStatus: Displays prerequisite eligibility status
 *
 * Types:
 * - ClueClientProps: Props interface for ClueClient
 * - ClueWrapperProps: Props interface for ClueWrapper
 * - RoutePattern: Union type for supported route patterns
 * - VerificationState: State interface for IYK verification
 * - NFTOwnershipState: State interface for NFT ownership checking
 * - MintingState: State interface for minting state machine
 * - EligibilityState: State interface for prerequisite eligibility
 */

export { ClueClient } from './ClueClient';
export type {
  ClueClientProps,
  RoutePattern,
  VerificationState,
  NFTOwnershipState,
  MintingState,
  EligibilityState
} from './ClueClient';

export { ClueWrapper } from './ClueWrapper';
export type { ClueWrapperProps } from './ClueWrapper';

export { ClaimForm } from './ClaimForm';
export type { ClaimFormProps } from './ClaimForm';

export { MintingSection } from './MintingSection';
export type { MintingSectionProps } from './MintingSection';

export { EligibilityStatus } from './EligibilityStatus';
export type { EligibilityStatusProps } from './EligibilityStatus';

// Re-export hooks
export { useMintingMachine } from './hooks';
export type {
  MintingStatus,
  MintingConfig,
  UseMintingMachineOptions,
  UseMintingMachineResult
} from './hooks';
